import { Component } from '@angular/core';
import { IzzyChannelMessageAttachmentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Channel Message Attachments') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzychannelmessageattachment-form',
    templateUrl: './izzychannelmessageattachment.form.component.html'
})
export class IzzyChannelMessageAttachmentFormComponent extends BaseFormComponent {
    public record!: IzzyChannelMessageAttachmentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'relationships', sectionName: 'Relationships', isExpanded: true },
            { sectionKey: 'attachmentDetails', sectionName: 'Attachment Details', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

